/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const o=50,t=5;export{t as minimumPixelsPerStrideForDisplayWhenScalingOff,o as pixelsPerCell};
